import { useTranslation } from 'react-i18next';

import SortingDropdown from 'components/filters/SortingDropdown';
import { ItemSortType } from 'services/sortType';

interface Option {
  value: ItemSortType;
  label: string;
}

interface Props {
  value: ItemSortType;
  testId?: string;
  onChange: (sortType: ItemSortType) => void;
}

export const ItemSortingDropdown = ({ value, testId, onChange }: Props) => {
  const { t } = useTranslation('item');

  const options: Option[] = [
    { value: 'RELEVANT', label: t('option.relevant') },
    { value: 'RECENT', label: t('option.recent') },
    { value: 'NEAREST', label: t('option.nearest') },
    { value: 'BEST_MATCH', label: t('option.best-match') },
    { value: 'CHEAPEST', label: t('option.cheapest') },
  ];

  return <SortingDropdown testId={testId} value={value} options={options} onChange={onChange} />;
};
